var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageHeader',{attrs:{"title":_vm.title,"icon":_vm.icon,"back":"","print":""},on:{"back":function($event){return _vm.$emit('back')},"print":_vm.delayedPrint}},[_c('div',{attrs:{"id":"printTarget"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }